// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "CardColor-module--bx--text-truncate--end--qj7Fb";
export var bxTextTruncateFront = "CardColor-module--bx--text-truncate--front--5uU6k";
export var card = "CardColor-module--card--f4ASr";
export var colorBlock = "CardColor-module--colorBlock--IsKbw";